import React, { useContext } from 'react';
import { CustomerContext } from '../../../context/CustomerContext';
import { AddressType, BankDetailType, PolicyHolderType } from '../CommonTypes';
import PageTitle from '../PageTitle';
import PolicyHolderInfo from './PolicyHolderInfo';
import { RoutePaths } from 'Constants/Common';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const PersonalDetailsPage = (): JSX.Element => {
    const { customer } = useContext(CustomerContext);

    if (!customer) return <></>;

    const navigate = useNavigate();
    const policyHolderAddress: AddressType = {
        addressLine1: customer.address.addressLine1,
        addressLine2: customer.address.addressLine2,
        townOrCity: customer.address.townOrCity,
        region: customer.address.region,
        country: customer.address.country,
        postcode: customer.address.postcode
    };

    const policyHolderBankDetail: BankDetailType = {
        accountHolderName: customer.bankDetail?.accountHolderName,
        accountNumber: customer.bankDetail?.accountNumber,
        sortCode: customer.bankDetail?.sortCode
    };

    const policyHolder: PolicyHolderType = {
        title: customer.title,
        firstName: customer.firstName,
        middleName: customer.middleName,
        lastName: customer.lastName,
        companyName: customer.companyName,
        address: policyHolderAddress,
        email: customer.email,
        supportingDocument1: customer.supportingDocument1,
        supportingDocument2: customer.supportingDocument2,
        bankDetail: policyHolderBankDetail
    };

    const onBackButtonClick = () => {
        navigate(RoutePaths.Home);
    };
    return (
        <>
            <div className='card page-content'>
                <PageTitle title={t('personal_details')} />
                <div className='card-body page-content-body'>
                    <PolicyHolderInfo
                        policyHolder={policyHolder}></PolicyHolderInfo>
                </div>
            </div>
            <div className='bottom-navigation'>
                <button
                    aria-label='back-button'
                    className='btn btn-secondary progress-button'
                    onClick={() => onBackButtonClick()}>
                    {t('back')}
                </button>
            </div>
        </>
    );
};

export default PersonalDetailsPage;
